import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-overlay-message.content.json';

@Component({
    selector: 'conversational-chat-overlay-message',
    templateUrl: './conversational-chat-overlay-message.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatOverlayMessageComponent {
    private readonly apContentService = inject(ApContentService);

    public readonly selectContinueConversation = output<void>();

    public constructor() {
        this.apContentService.addContentItems(content);
    }

    public setContinueConversation(): void {
        this.selectContinueConversation.emit();
    }
}
